// @ts-ignore
export * from './insertPermissions.gql'
// @ts-ignore
export * from './removePermissions.gql'
